import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Sidebar';
import MobileNav from '../Components/MobileNav'; // ADD THIS
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Loader from '../Components/Loader';

export default function PlayerProfile() {
  const { id } = useParams();
  const isMobile = useIsMobile(); // ADD THIS
  
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [isFollowing, setIsFollowing] = useState(false);
  const [followLoading, setFollowLoading] = useState(false);
  
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('sidebarCollapsed') === 'true';
  });
  
  const [followerCount, setFollowerCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);

  const handleSetCollapsed = (value) => {
    setCollapsed(value);
    localStorage.setItem('sidebarCollapsed', value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      
      const { data: { user } } = await supabase.auth.getUser();
      setCurrentUser(user);

      const { data } = await supabase
        .from('igd')
        .select('*')
        .eq('user_id', id)
        .single();

      setProfile(data);

      const { count: followers } = await supabase
        .from('followers')
        .select('*', { count: 'exact', head: true })
        .eq('following_id', id);

      const { count: following } = await supabase
        .from('followers')
        .select('*', { count: 'exact', head: true })
        .eq('follower_id', id);

      setFollowerCount(followers || 0);
      setFollowingCount(following || 0);

      if (user && user.id !== id) {
        const { data: followData } = await supabase
          .from('followers')
          .select('*')
          .eq('follower_id', user.id)
          .eq('following_id', id)
          .single();
        
        setIsFollowing(!!followData);
      }

      setLoading(false);
    };

    fetchData();
  }, [id]);

  const handleFollowToggle = async () => {
    if (!currentUser) return;
    
    setFollowLoading(true);
    
    try {
      if (isFollowing) {
        await supabase
          .from('followers')
          .delete()
          .eq('follower_id', currentUser.id)
          .eq('following_id', id);
        
        setIsFollowing(false);
        setFollowerCount(prev => prev - 1);
      } else {
        await supabase
          .from('followers')
          .insert({
            follower_id: currentUser.id,
            following_id: id
          });
        
        setIsFollowing(true);
        setFollowerCount(prev => prev + 1);
      }
    } catch (err) {
      console.error('Follow error:', err);
    }
    
    setFollowLoading(false);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        background: '#020617', 
        minHeight: '100vh',
        flexDirection: isMobile ? 'column' : 'row',
      }}>
        {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={handleSetCollapsed} />}
        <div style={{ 
          flex: 1, 
          marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: isMobile ? '20px' : '0',
        }}>
          <Loader size={isMobile ? 80 : 120} />
        </div>
        {isMobile && <MobileNav />}
      </div>
    );
  }

  if (!profile)
    return (
      <div style={{ 
        display: 'flex', 
        background: '#020617', 
        minHeight: '100vh',
        flexDirection: isMobile ? 'column' : 'row',
      }}>
        {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={handleSetCollapsed} />}
        <div style={{ 
          flex: 1, 
          marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
          padding: isMobile ? '20px' : '40px', 
          color: 'white',
          paddingBottom: isMobile ? '90px' : '40px',
        }}>
          Profile not found.
        </div>
        {isMobile && <MobileNav />}
      </div>
    );

  const isOwnProfile = currentUser?.id === id;

  return (
    <div style={{ 
      display: 'flex', 
      background: '#020617', 
      minHeight: '100vh',
      flexDirection: isMobile ? 'column' : 'row',
    }}>
      {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={handleSetCollapsed} />}

      <div style={{ 
        flex: 1, 
        marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
        padding: isMobile ? '16px' : '40px', 
        color: 'white',
        transition: 'margin-left 0.3s ease',
        overflowX: 'hidden',
        paddingBottom: isMobile ? '90px' : '40px',
      }}>
        <div
          style={{
            background: '#0f172a',
            padding: isMobile ? '24px' : '40px',
            borderRadius: isMobile ? '16px' : '18px',
            maxWidth: '850px',
            boxShadow: '0 12px 30px rgba(0,0,0,0.4)',
          }}
        >
          {/* Header */}
          <div style={{ 
            display: 'flex', 
            gap: isMobile ? '16px' : '30px', 
            alignItems: 'center', 
            flexWrap: 'wrap',
            flexDirection: isMobile ? 'column' : 'row',
            textAlign: isMobile ? 'center' : 'left',
          }}>
            <img
              src={profile.avatar_url || 'https://i.pravatar.cc/150'}
              alt={profile.avatarName}
              style={{
                width: isMobile ? '100px' : '140px',
                height: isMobile ? '100px' : '140px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: isMobile ? '3px solid #38bdf8' : '3px solid #38bdf8',
              }}
            />

            <div style={{ flex: 1, minWidth: 0 }}>
              <h1 style={{ 
                marginBottom: isMobile ? '12px' : '8px', 
                fontSize: isMobile ? '24px' : '32px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }} title={profile.avatarName}>
                {profile.avatarName}
              </h1>
              
              {/* Follower/Following Counts */}
              <div style={{ 
                display: 'flex', 
                gap: isMobile ? '20px' : '25px', 
                marginBottom: isMobile ? '12px' : '15px',
                justifyContent: isMobile ? 'center' : 'flex-start',
              }}>
                <div>
                  <span style={{ fontWeight: 'bold', fontSize: isMobile ? '16px' : '18px' }}>{followerCount}</span>
                  <span style={{ opacity: 0.7, marginLeft: '5px', fontSize: isMobile ? '13px' : '14px' }}>Followers</span>
                </div>
                <div>
                  <span style={{ fontWeight: 'bold', fontSize: isMobile ? '16px' : '18px' }}>{followingCount}</span>
                  <span style={{ opacity: 0.7, marginLeft: '5px', fontSize: isMobile ? '13px' : '14px' }}>Following</span>
                </div>
              </div>

              <p style={{ opacity: 0.85, fontSize: isMobile ? '14px' : '16px', marginBottom: '4px' }}>
                ⭐ Rank: {profile.rank || 'No Rank'}
              </p>
              <p style={{ opacity: 0.85, fontSize: isMobile ? '14px' : '16px', marginBottom: '4px' }}>
                🛡️ Clan: {profile.clan || 'No Clan'}
              </p>
              <p style={{ opacity: 0.85, fontSize: isMobile ? '14px' : '16px', marginBottom: '4px' }}>
                🪙 Tokens: {profile.token || '0'}
              </p>
              {profile.current_award && (
                <p style={{ opacity: 0.85, color: '#fbbf24', fontSize: isMobile ? '14px' : '16px' }}>
                  🏆 Alpha Medal of Honour
                </p>
              )}
            </div>
          </div>

          {/* Follow Button - Only show if not own profile */}
          {!isOwnProfile && (
            <div style={{ 
              marginTop: isMobile ? '24px' : '30px',
              display: 'flex',
              justifyContent: isMobile ? 'center' : 'flex-start',
            }}>
              <button
                onClick={handleFollowToggle}
                disabled={followLoading}
                style={{
                  padding: isMobile ? '14px 32px' : '12px 30px',
                  borderRadius: '10px',
                  border: 'none',
                  background: isFollowing 
                    ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' 
                    : 'linear-gradient(135deg, #38bdf8 0%, #818cf8 100%)',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: isMobile ? '16px' : '16px',
                  cursor: followLoading ? 'not-allowed' : 'pointer',
                  opacity: followLoading ? 0.7 : 1,
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  minHeight: '48px', // Touch target
                  minWidth: '120px',
                }}
              >
                {followLoading 
                  ? 'Processing...' 
                  : isFollowing 
                    ? 'Unfollow' 
                    : 'Follow'}
              </button>
            </div>
          )}

          {/* Stats Grid */}
          <div style={{ 
            marginTop: isMobile ? '30px' : '40px',
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(150px, 1fr))',
            gap: isMobile ? '12px' : '20px',
          }}>
            <StatBox icon="⚔️" label="Kills" value={profile.kills || 0} color="#22c55e" isMobile={isMobile} />
            <StatBox icon="💀" label="Deaths" value={profile.deaths || 0} color="#ef4444" isMobile={isMobile} />
            <StatBox icon="💔" label="Suicides" value={profile.suicides || 0} color="#8b5cf6" isMobile={isMobile} />
            <StatBox icon="🔪" label="Betrayals" value={profile.betrayals || 0} color="#f97316" isMobile={isMobile} />
          </div>

          {/* K/D Ratio */}
          {(profile.kills || profile.deaths) && (
            <div style={{ 
              marginTop: isMobile ? '24px' : '30px', 
              padding: isMobile ? '16px' : '20px', 
              background: 'rgba(56, 189, 248, 0.1)', 
              borderRadius: '12px',
            }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px',
              }}>
                <span style={{ fontSize: isMobile ? '14px' : '16px' }}>K/D Ratio</span>
                <span style={{ 
                  fontSize: isMobile ? '20px' : '24px', 
                  fontWeight: 'bold',
                }}>
                  {profile.deaths === 0 ? profile.kills : (profile.kills / profile.deaths).toFixed(2)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {isMobile && <MobileNav />}
    </div>
  );
}

// Stat Box Component
function StatBox({ icon, label, value, color, isMobile }) {
  return (
    <div style={{
      background: 'rgba(30, 41, 59, 0.5)',
      padding: isMobile ? '16px' : '20px',
      borderRadius: '12px',
      textAlign: 'center',
      border: `2px solid ${color}40`,
    }}>
      <div style={{ fontSize: isMobile ? '24px' : '28px', marginBottom: isMobile ? '6px' : '8px' }}>
        {icon}
      </div>
      <div style={{ 
        fontSize: isMobile ? '22px' : '28px', 
        fontWeight: 'bold', 
        color: color,
      }}>
        {value}
      </div>
      <div style={{ 
        fontSize: isMobile ? '10px' : '12px', 
        opacity: 0.7, 
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      }}>
        {label}
      </div>
    </div>
  );
}